import { Link } from "react-router-dom";

// Long-form GTGS lockup (icon + wordmark) — transparent PNG, renders cleanly on dark/light themes.
const LOGO_URL = "/gtgs-long-logo.png";

export const Logo = ({ size = "md", to = "/" }) => {
  const heightClass =
    size === "lg"
      ? "h-12 sm:h-16"
      : size === "sm"
        ? "h-7"
        : "h-9 sm:h-10";

  const content = (
    <div className="flex items-center" data-testid="gtgs-logo">
      <img
        src={LOGO_URL}
        alt="Grace the Geek Studios"
        className={`${heightClass} w-auto object-contain select-none drop-shadow-[0_0_14px_rgba(109,91,227,0.35)] dark:drop-shadow-[0_0_14px_rgba(109,91,227,0.45)]`}
        draggable={false}
      />
    </div>
  );

  return to ? <Link to={to} aria-label="Grace the Geek Studios">{content}</Link> : content;
};

export default Logo;
